export function headerFunc() {
  // ハンバーガーメニュー実装
  $('.l-header__toggle-button').on('click', function() {
    $('.l-header__toggle-button').toggleClass('l-header__toggle-button--close');
    $('.l-header__nav').toggleClass('l-header__nav--open');
  });
}